import WebPopupBlockSelector from './webPopupBlockSelector';
import WebPopupBlock from './webPopupBlock';
import colorPicker from '@caohenghu/vue-colorpicker';
import ImageManager from '@/components/campaign/contentBuilder/imageUpload/imageUpload';
import draggable from 'vuedraggable';
import customerService from '@/services/customer';
import MceTextEditor from '@/components/mceTextEditor/mceTextEditor';
const _ = require('lodash');

let customerAttributesRegex = /^[a-zA-Z0-9_ ]*$/;
export default {
  name: 'dragDropEditor',
  props: {},
  components: {
    WebPopupBlock,
    WebPopupBlockSelector,
    colorPicker,
    draggable,
    ImageManager,
    MceTextEditor
  },
  data() {
    return {
      webMessageId: null,
      drag: false,
      blockList: [],
      selectedLeftSideTab: 'general',
      selectedLeftSitePopupScope: 'general',
      selectedLeftSiteSettingsScope: 'row',
      selectedBlock: null,
      selectedRow: null,

      isThankYouPage: false,
      thankYouPageEnabled: true,
      blocksInfo: {
        mainBlocks: [],
        mainHtml: '',
        thankYouBlocks: [],
        thankYouHtml: ''
      },

      // Default Popup Settings
      pupupAppereance: {
        type: 'popup',
        flyoutPosition: { x: 'right', y: 'bottom' },
        overlayColor: 'rgba(0,0,0,0.34)',
        width: 550,
        closeButtonColor: 'rgba(92,92,92,1)',
        borderRadius: 10,
        background: {
          image: '',
          imageSrcMode: 'upload',
          imageAlignment: '50% 50%',
          imageSize: 'cover',
          color: '#FFFFFF'
        },
        customerFields: [],
        customCss: null,
        customJs: null,

        // Form submit info.
        formSubmit: {
          action: 'close',
          redirectUrl: ''
        }
      },
      popformAccordianVal: 'fields',

      // Customer Attributes Section
      customerAttributesInput: {
        key: '',
        value: ''
      },
      // Form validation
      customerAttributeFormRules: {
        key: [
          {
            required: true,
            message: 'Attribute Name is required.'
          },
          {
            validator: function (rule, value, callback) {
              if (!customerAttributesRegex.test(value)) {
                callback(new Error('Only alphabets and space are allowed.'));
              } else callback();
            }
          },
          { min: 1, max: 10, message: 'Name can not exceed 10 characters.' }
        ],
        value: [
          {
            required: true,
            message: 'Attribute Value is required.'
          },
          {
            validator: function (rule, value, callback) {
              if (!customerAttributesRegex.test(value)) {
                callback(new Error('Only alphabets and space are allowed.'));
              } else callback();
            }
          },
          { min: 1, max: 10, message: 'Value can not exceed 10 characters.' }
        ]
      },

      // Customers field list for form
      customerFieldList: null,
      currentFormFieldEdited: null,

      // Drag drop variables
      newBlockDragDropInProcess: false,
      currentDragBlockId: null,
      currentDragBlockHintSide: 'top',

      // Popover Flags
      imageLinkDynmicUserPopver: false,
      buttonLinkDynmicUserPopver: false,

      fontsList: null
    };
  },

  watch: {
    selectedBlock: function () {
      if (this.selectedBlock == null) {
        this.selectedLeftSideTab = 'general';
      }
    },
    isThankYouPage: function (newValue, oldValue) {
      this.onThankYouModeToggled(newValue, oldValue);
    }
  },

  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost'
      };
    },
    closeButtonPadding: function () {
      return parseInt(this.pupupAppereance.borderRadius / 5) + 7 + 'px !important';
    }
  },

  methods: {
    onThankYouModeToggled(newValue, oldValue) {
      if (oldValue == true) {
        // It was thank you page earlier.
        this.blocksInfo.thankYouHtml = this.prepareHtml(true);
        this.blocksInfo.thankYouBlocks = this.blockList;
      } else {
        // It was main page earlier.
        this.blocksInfo.mainHtml = this.prepareHtml();
        this.blocksInfo.mainBlocks = this.blockList;
      }

      if (newValue == true) this.blockList = this.blocksInfo.thankYouBlocks;
      else this.blockList = this.blocksInfo.mainBlocks;
    },

    showBlockSelector(index, columnIndex, columnVerticalIndex) {
      this.$refs.blockSelector.showPopup(index, columnIndex, columnVerticalIndex);
    },

    onPopupAppreanctTypeChange() {
      if (this.isThankYouPage) {
        this.blocksInfo.thankYouBlocks = this.blockList;
        this.blockList = this.blocksInfo.mainBlocks;
        requestAnimationFrame(() => {
          this.blocksInfo.mainHtml = this.prepareHtml(false);
          this.blockList = this.blocksInfo.thankYouBlocks;
        });
      } else {
        this.blocksInfo.mainBlocks = this.blockList;
        this.blockList = this.blocksInfo.thankYouBlocks;
        requestAnimationFrame(() => {
          this.blocksInfo.thankYouHtml = this.prepareHtml(true);
          this.blockList = this.blocksInfo.mainBlocks;
        });
      }
    },

    addBlock(info) {
      Array.prototype.insert = function (index, item) {
        this.splice(index, 0, item);
      };

      if (info.columnIndex === undefined && info.columnIndex == null) {
        this.blockList.insert(info.index, info.block);
        this.onBlockSelect(info.block, info.block);
      } else {
        this.blockList[info.index].content.columns[info.columnIndex].insert(info.columnVerticalIndex, info.block);
        this.onBlockSelect(info.block, this.blockList[info.index]);
      }
    },

    removeBlock(index) {
      this.$confirm('Delete block?', 'Warning', {
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.blockList.splice(index, 1);
        requestAnimationFrame(() => {
          this.selectedBlock = null;
          this.$forceUpdate();
        });
      });
    },

    copyBlock(index) {
      let newCopy = JSON.parse(JSON.stringify(this.blockList[index]));
      newCopy.id = new Date().valueOf();
      newCopy.showDroppers = false;
      newCopy.showBlockDroppers = false;

      // Add new ids for sub columns as well
      if (newCopy.type.startsWith('columns')) {
        for (let i = 0; i < newCopy.content.columns.length; i++) {
          for (let j = 0; j < newCopy.content.columns[i].length; j++) {
            newCopy.content.columns[i][j].id = new Date().valueOf() + i.toString() + j.toString();
            newCopy.content.columns[i][j].showDroppers = false;
          }
        }
      }

      Array.prototype.insert = function (index, item) {
        this.splice(index, 0, item);
      };

      this.blockList.insert(index, newCopy);
      this.successToast('Block copied.');
    },

    removeBlockFromColumn(index, columnIndex, columnVerticalIndex) {
      let columnRowList = this.blockList[index].content.columns[columnIndex];
      columnRowList.splice(columnVerticalIndex, 1);
      requestAnimationFrame(() => {
        this.selectedBlock = null;
      });
    },

    copyBlockToColumn(index, columnIndex, columnVerticalIndex) {
      let newCopy = JSON.parse(JSON.stringify(this.blockList[index].content.columns[columnIndex][columnVerticalIndex]));
      newCopy.id = new Date().valueOf();
      newCopy.showDroppers = false;
      newCopy.showBlockDroppers = false;

      Array.prototype.insert = function (index, item) {
        this.splice(index, 0, item);
      };

      this.blockList[index].content.columns[columnIndex].insert(columnVerticalIndex, newCopy);
      this.successToast('Block copied.');
    },

    onBlockSelect(block, row) {
      this.selectedBlock = block;
      this.selectedRow = row;
      this.selectedLeftSideTab = 'settings';
      if (this.selectedBlock.type.startsWith('column')) {
        this.selectedLeftSiteSettingsScope = 'row';
      } else {
        this.selectedLeftSiteSettingsScope = 'block';
      }

      if (this.selectedBlock.type == 'text') {
        requestAnimationFrame(() => {
          this.$refs.mceEditor.setContent(this.selectedBlock.content.html);
        });
      }
    },

    setColor(obj, property, args) {
      let color = args[0];
      obj[property] = this.RGBAToHexA(color.rgba.r, color.rgba.g, color.rgba.b, color.rgba.a).toUpperCase();

      // If radio button color, rerender component.
      if (property == 'radioButtonColor') {
        this.$forceUpdate();
      }
    },

    setButtonTextColor(color) {
      this.selectedBlock.content.textColor = this.RGBAToHexA(color.rgba.r, color.rgba.g, color.rgba.b, color.rgba.a).toUpperCase();
    },

    setButtonColor(color) {
      this.selectedBlock.content.buttonColor = this.RGBAToHexA(color.rgba.r, color.rgba.g, color.rgba.b, color.rgba.a).toUpperCase();
    },

    setButtonSectionColor(block, propertyName, color) {
      block.content[propertyName] = this.RGBAToHexA(color.rgba.r, color.rgba.g, color.rgba.b, color.rgba.a).toUpperCase();
      console.log(block.content, propertyName);
    },

    setBackgroundColorToProperty(obj, property, color) {
      let rgba = `rgba(${color.rgba.r},${color.rgba.g},${color.rgba.b},${color.rgba.a})`;
      obj[property] = rgba;
    },

    setDividerColor(color) {
      this.selectedBlock.content.color = this.RGBAToHexA(color.rgba.r, color.rgba.g, color.rgba.b, color.rgba.a).toUpperCase();
    },

    onBlockEditorHtmlChange(data) {
      this.selectedBlock.content.html = data.data;
    },

    getBorderRadiusForBlock(inputIndex) {
      let value = '0px';
      if (this.blockList.length == 1) {
        value = this.pupupAppereance.borderRadius + 'px';
      } else if (inputIndex == 0) {
        value = `${this.pupupAppereance.borderRadius + 'px'} ${this.pupupAppereance.borderRadius + 'px'} 0px 0px`;
      } else if (inputIndex == this.blockList.length - 1) {
        value = `0px 0px ${this.pupupAppereance.borderRadius + 'px'} ${this.pupupAppereance.borderRadius + 'px'}`;
      }
      return value;
    },

    onFlyoutPositionChange(y, x) {
      this.pupupAppereance.flyoutPosition.x = x;
      this.pupupAppereance.flyoutPosition.y = y;
    },

    //#region ----------- Start: Customer Attribute Section ---------------

    async validateAddCustomerAttributeForm() {
      return new Promise((resolve) => {
        this.$refs['customerAttributesForm'].validate((valid) => {
          let isInvalid = valid === false;
          resolve(!isInvalid);
        });
      });
    },

    async onAddCustomerAttribute() {
      let isValidInput = await this.validateAddCustomerAttributeForm();
      if (!isValidInput) return;

      this.pupupAppereance.customerFields.push({
        key: this.customerAttributesInput.key,
        value: this.customerAttributesInput.value
      });

      this.$refs['customerAttributesForm'].resetFields();
    },

    //#endregion ----------- End: Customer Attribute Section ---------------

    //#region ----------- Start: Form Methods ---------------

    // async onEditFormField(fieldIndex) {
    //   // Check for already being edited field.
    //   if (this.currentFormFieldEdited) {
    //     let olderFormField = this.currentFormFieldEdited;
    //     let orderFormFieldIndex = this.currentFormFieldEdited.index;
    //     try {
    //       await this.$swal({
    //         title: `Ignore changes in ${olderFormField.name} ?`,
    //         text: '',
    //         type: 'warning',
    //         showCancelButton: true,
    //         confirmButtonColor: '#3085d6',
    //         cancelButtonColor: '#d33',
    //         confirmButtonText: 'Yes'
    //       });

    //       this.selectedBlock.content.fields[orderFormFieldIndex].editMode = false;
    //     } catch (err) {
    //       console.log(' in catch return');
    //       // Its no, so return.
    //       return;
    //     }
    //   }

    //   // If any field is being edited, show ignore message.
    //   this.currentFormFieldEdited = this.selectedBlock.content.fields[fieldIndex];
    //   this.currentFormFieldEdited.index = fieldIndex;

    //   this.selectedBlock.content.fields[fieldIndex].editMode = true;
    // },

    // async onCancelFormFieldEdit() {
    //   let fieldIndex = this.currentFormFieldEdited.index;
    //   this.selectedBlock.content.fields[fieldIndex].editMode = false;
    //   this.currentFormFieldEdited = null;
    // },

    // async onSaveFormField() {
    //   let fieldIndex = this.currentFormFieldEdited.index;
    //   this.selectedBlock.content.fields[fieldIndex] = JSON.parse(JSON.stringify(this.currentFormFieldEdited));
    //   this.selectedBlock.content.fields[fieldIndex].editMode = false;
    //   this.currentFormFieldEdited = null;

    //   this.selectedBlock.editUpdateId = new Date().valueOf();

    //   this.$forceUpdate();
    //   console.log('did force update..');
    // },

    //#endregion ----------- End: Form Methods ---------------

    //#region ----------- Start: Image Mgt---------------

    onPopupImageUpload(obj, prop, img) {
      obj[prop] = img.url;
    },

    onImageUpload(block, propertyName, img) {
      block.content[propertyName] = img.url;
    },

    showImageuploader(refName) {
      this.$refs[refName].toggleVisiblity();
    },

    //#endregion ----------- End: Image Mgt---------------

    //#region ----------- Start: Subscribe Form Mgt---------------

    onAddFormField(fildColumnName) {
      // Read field info
      let fieldInfo = _.find(this.customerFieldList, (item) => {
        return item.columnName == fildColumnName;
      });
      if (!fieldInfo) return;

      // Add Field.
      this.selectedBlock.content.fields.push(JSON.parse(JSON.stringify(fieldInfo)));
    },

    // Fetch customer property list
    async fetCustomerFieldList() {
      let result = await customerService.fetchUserPropertyList(null, this);
      if (result.data.success) {
        // Add Email, Phone, Name
        let email = _.find(result.data.data, (item) => {
          return item.columnName == 'email';
        });
        let mobile = _.find(result.data.data, (item) => {
          return item.columnName == 'mobile';
        });
        let name = _.find(result.data.data, (item) => {
          return item.columnName == 'name';
        });
        let customFields = [email, mobile, name];

        // Add custom fields.
        for (let i = 0; i < result.data.data.length; i++) {
          if (result.data.data[i].isCustom) {
            customFields.push(result.data.data[i]);
          }
        }

        if (customFields.length >= 4) {
          customFields[3].isDivided = true;
        }

        // Add aditional metadata
        for (let i = 0; i < customFields.length; i++) {
          customFields[i].label = customFields[i].placeholder = 'Enter ' + customFields[i].name;
          customFields[i].required = true;
          customFields[i].editMode = false;
          customFields[i].labelText = customFields[i].name;

          // Add input ui.
          customFields[i].inputUiType = 'input';
          customFields[i].inputUiAllowedValues = [];
          customFields[i].inputDateTypeMeta = {
            format: 'ddmmyyyy',
            seperator: '/'
          };
        }

        this.customerFieldList = customFields;
      }
    },

    //#endregion ----------- End: Subscribe Form Mgt---------------

    //#region ----------- Parent Communication Methods---------------

    prepareHtml(isThankYouPage) {
      let popoverayId = 'grw_popup_overlay_' + Math.random().toString(36).substring(2) + Date.now().toString(36);
      let style = `
        .final-grw-widget {position: fixed !important;}@media only screen and (max-width: 480px) {.final-grw-widget .mobileHidden {display: none !important;}}@media only screen and (min-width: 480px) {.final-grw-widget .desktopHidden {display: none !important;}}.grw-thankyou-section {display: none !important;}@keyframes grwWebMessageAnimation {0% {opacity: 0;}100% {opacity: 1;}}.grw-widget {position: absolute;animation: grwWebMessageAnimation 1s forwards;animation-fill-mode: forwards;}.grw-widget .blockSection {overflow: hidden;background-size: cover;}.grw-widget .bock-image-background {background-size: cover;background-position: center;}.grw-widget .buttonSection .buttonStyle {width: auto;display: inline-block;cursor: pointer;}.grw-widget .textSection p {margin: 0px !important;}.grw-widget .dividerSection .divider {margin: auto;}.grw-widget .imageSection {line-height: 0;}.grw-widget .imageSection .section-img {margin: auto;}.grw-widget .grw-row-section {width: 100%;display: flex;}.grw-widget .grw-row-section .grw-row-column {overflow: hidden;display: flex;flex-direction: column;justify-content: center;}.grw-widget .grw-row-section .grw-row-column .section-column-block {position: relative;overflow: hidden;}.grw-widget a, .grw-widget a:hover {text-decoration: none;}.grw-widget .grw-web-popup-content {overflow: hidden;}.grw-widget .formSection {overflow: hidden;width: 100%;box-sizing: border-box;}.grw-widget .formSection .formItem {width: 100%;margin-bottom: 17px;}.grw-widget .formSection .formItem .fieldLabel {margin-bottom: 4px;}.grw-widget .formSection .formItem .textInput {border-width: 1px;border-style: solid;border-color: #cccccc;padding: 10px;color: black;background-color: white;font-size: 12px;width: 100%;border-radius: 0px;box-sizing: border-box;}.grw-widget .formSection .formItem .grw-msg-form-error {color: red;font-size: 12px;padding-top: 4px;display: none;}.grw-widget .formSection .submitButtonContainer {width: 100%;text-align: center;box-sizing: border-box;}.grw-widget .formSection .submitButtonContainer .submitButton {border: none;padding: 10px 15px;cursor: pointer;}.grw-widget .grw-message-close-container {position: absolute;top: 6px;right: 6px;z-index: 100;cursor: pointer;width: 20px;height: 20px;background: rgba(0, 0, 0, 0.3);border-radius: 50%;box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.3);-moz-box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.3);-webkit-box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.3);-moz-transition: box-shadow 0.3s ease;-o-transition: box-shadow 0.3s ease;-ms-transition: box-shadow 0.3s ease;-webkit-transition: box-shadow 0.3s ease;transition: box-shadow 0.3s ease;}.grw-widget .grw-message-close-container .grw-message-close-img {position: absolute;width: 10px;height: 10px;left: 50%;top: 50%;-moz-transform: translate(-50%, -50%);-o-transform: translate(-50%, -50%);-ms-transform: translate(-50%, -50%);-webkit-transform: translate(-50%, 50%);transform: translate(-50%, -50%);}@media only screen and (max-width: 480px) {.grw-widget {-moz-background-clip: padding;-webkit-background-clip: padding;background-clip: padding-box;border-left: 22px solid transparent;border-right: 22px solid transparent;-webkit-transform-origin-x: 50%;}.grw-widget .grw-message-close-container {top: 12px !important;right: 12px !important;width: 30px !important;height: 30px !important;}.grw-widget .grw-message-close-container .grw-message-close-img {position: absolute !important;width: 15px !important;height: 15px !important;left: 50% !important;top: 50% !important;}.grw-widget .mobileHidden {display: none !important;}}@media only screen and (max-width: 480px) and (-webkit-min-device-pixel-ratio: 0) and (max-device-width: 1024px) {.grw-widget select, .grw-widget textarea, .grw-widget input {font-size: 16px;}}.grw-popup-overlay {overflow-x: hidden !important;display: flex;justify-content: center;align-items: center;flex-direction: column;}.grw-web-popup {margin: 0vh auto 0px auto;position: relative;align-self: center;}.grw-flyout-container .grw-web-popup-content {box-shadow: 0 11px 32px 5px rgba(54, 61, 77, 0.15) !important;}.grw-flyout-v-top {top: 20px;-webkit-transform-origin: 0% 0%;-moz-transform-origin: 0% 0%;-o-transform-origin: 0% 0%;-ms-transform-origin: 0% 0%;transform-origin: 0% 0%;}.grw-flyout-v-bottom {bottom: 20px;-webkit-transform-origin: 50% 100%;-moz-transform-origin: 50% 100%;-o-transform-origin: 50% 100%;-ms-transform-origin: 50% 100%;transform-origin: 50% 100%;}@media only screen and (min-width: 480px) {.grw-flyout-h-left {left: 20px;}.grw-flyout-h-right {right: 20px;}.grw-flyout-h-center {margin: auto;left: 0;right: 0;}}@media only screen and (max-width: 480px) {.grw-flyout-container {-webkit-transform-origin-x: 0px;}.grw-flyout-h-left, .grw-flyout-h-right, .grw-flyout-h-center {margin: auto;left: auto;right: auto;}.grw-flyout-mobile-adjust {width: auto !important;}}.grw-web-popup-pwrdby {width: 100%;text-align: center;margin-top: -2px;}.grw-web-popup-pwrdby a, .grw-web-popup-pwrdby a:active {color: #ffffff40;font-size: 8px;letter-spacing: 1px;text-decoration: none;opacity: 1;}
      `;
      // display: flex;align-items: center;justify-content: center;
      // Generate Html
      let html = '';
      if (!isThankYouPage) {
        html = `<style>${style}</style>`;
      }

      if (this.pupupAppereance.type == 'popup') {
        html += `<div id="${popoverayId}" class="grw-popup-overlay ${isThankYouPage ? 'grw-thankyou-section' : 'grw-main-section'}" style="
        position: fixed; top: 0; right: 0; bottom: 0; left: 0;
        overflow: auto; margin: 0; display: flex; justify-content: center; align-items: center;
        background: ${this.pupupAppereance.overlayColor};
        z-index: 999999999999;">
        <div class="grw-widget grw-widget-${this.webMessageId} grw-web-popup final-grw-widget" 
          style="width: ${this.pupupAppereance.width}px; 
            overflow: hidden;">
            
            ${this.prepareBoxHtml()}

          <div class="grw-web-popup-pwrdby">
            <a target="_blank" href="https://growlytics.in/?utm_source=client-sdk&utm_campaign=popup"> 
              Powered By <b>Growlytics</b>
            </a>
          </div>
        </div>        
        </div>`;
      } else {
        // Decide class for flyout positioning.
        let xClass = 'grw-flyout-h-' + this.pupupAppereance.flyoutPosition.x;
        let yClass = 'grw-flyout-v-' + this.pupupAppereance.flyoutPosition.y;
        if (this.pupupAppereance.width < 410) {
          xClass += ` grw-flyout-mobile-adjust`;
        }
        html += `<div id="${popoverayId}" 
          class="grw-widget grw-widget-${this.webMessageId} grw-flyout-container final-grw-widget ${xClass} ${yClass}  ${isThankYouPage ? 'grw-thankyou-section' : 'grw-main-section'}" 
          style="overflow: auto; display: flex; justify-content: center; align-items: center; background: transparent;
          z-index: 999999999999; width: ${this.pupupAppereance.width}px;">
              ${this.prepareBoxHtml()}
          </div>`;
      }

      return html;
    },

    prepareBoxHtml() {
      let html = `<div class="grw-web-popup-content" style="
            width: 100%; 
            background-color: ${this.pupupAppereance.background.color};
            background-image: ${this.pupupAppereance.background.image ? 'url(' + this.pupupAppereance.background.image + ')' : 'none'};
            background-position: ${this.pupupAppereance.background.imageAlignment};
            background-size: ${this.pupupAppereance.background.imageSize};
            border-radius: ${this.pupupAppereance.borderRadius}px;
          ">
          <div role="button" class="grw-message-close grw-message-close-container" title="Close" aria-label="Close" tabindex="5" style="top: ${this.closeButtonPadding}; right: ${this.closeButtonPadding}">
          <img alt="Close" class="grw-message-close-img" src="https://static.growlytics.in/on-site/popup-close-button.svg" />
          </div>
         `;

      // Add Dynamic Content.
      var s = new XMLSerializer();
      for (let i = 0; i < this.blockList.length; i++) {
        let blockElement = document.getElementById('block_' + this.blockList[i].id);
        blockElement = blockElement.cloneNode(true);
        let elementsToRemove = blockElement.getElementsByClassName('to-be-removed');
        while (elementsToRemove.length > 0) {
          for (let j = 0; j < elementsToRemove.length; j++) {
            elementsToRemove[j].remove();
          }
          elementsToRemove = blockElement.getElementsByClassName('to-be-removed');
        }

        html += s.serializeToString(blockElement);
      }

      html += `</div>`;
      return html;
    },

    getProcessedContents() {
      // Update records.
      if (this.isThankYouPage) {
        this.blocksInfo.thankYouBlocks = this.blockList;
        this.blocksInfo.thankYouHtml = this.prepareHtml(true);
      } else {
        this.blocksInfo.mainBlocks = this.blockList;
        this.blocksInfo.mainHtml = this.prepareHtml();
      }

      return {
        json: {
          appereance: this.pupupAppereance,
          rows: this.blocksInfo.mainBlocks,
          thankYouRows: this.blocksInfo.thankYouBlocks
        },
        html: this.blocksInfo.mainHtml,
        thankYouHtml: this.blocksInfo.thankYouHtml
      };
    },

    renderContent(id, type, inputData) {
      this.webMessageId = id;
      this.webMessageType = type;
      this.selectedBlock = null;
      this.isThankYouPage = false;
      this.blockList = [];

      this.pupupAppereance.type = this.webMessageType;

      let contentJson = inputData.json;
      if (typeof contentJson == 'string') {
        contentJson = JSON.parse(contentJson);
      }

      if (!contentJson) return;

      // Set incoming html
      this.blocksInfo.mainHtml = inputData.html ? inputData.html : '';
      this.blocksInfo.thankYouHtml = inputData.thankyou_html ? inputData.thankyou_html : '';

      // Iterate and populate main rows.
      let originalBlockList = this.$refs.blockSelector.blocks;
      this.blocksInfo.mainBlocks = [];
      for (let i = 0; i < contentJson.rows.length; i++) {
        let modifiedBlock = this.backfillOldSavedSettings(contentJson.rows[i], originalBlockList);
        this.blocksInfo.mainBlocks.push(modifiedBlock);
      }

      if (contentJson.thankYouRows) {
        this.blocksInfo.thankYouBlocks = [];
        for (let i = 0; i < contentJson.thankYouRows.length; i++) {
          let modifiedBlock = this.backfillOldSavedSettings(contentJson.thankYouRows[i], originalBlockList);
          this.blocksInfo.thankYouBlocks.push(modifiedBlock);
        }
      }

      this.pupupAppereance = this.overrideJson(this.pupupAppereance, contentJson.appereance, false);
      this.pupupAppereance.type = this.webMessageType;

      this.blockList = this.blocksInfo.mainBlocks;
    },

    backfillOldSavedSettings(savedBlock, originalBlockList) {
      let originalBlock = _.find(originalBlockList, (origBlock) => {
        return origBlock.type == savedBlock.type;
      });
      originalBlock = JSON.parse(JSON.stringify(originalBlock));

      // Override Settings.
      savedBlock = this.overrideJson(originalBlock, savedBlock);

      // If column, modify sub blocks recursively.
      if (savedBlock.type.startsWith('columns')) {
        for (let i = 0; i < savedBlock.content.columns.length; i++) {
          for (let j = 0; j < savedBlock.content.columns[i].length; j++) {
            savedBlock.content.columns[i][j] = this.backfillOldSavedSettings(savedBlock.content.columns[i][j], originalBlockList);
          }
        }
      }

      // If form, iterate and modify form fields manually
      if (savedBlock.type == 'form') {
        for (let i = 0; i < savedBlock.content.fields.length; i++) {
          // Re-populate original block, since at override, original block gets modified.
          let originalBlock = _.find(originalBlockList, (origBlock) => {
            return origBlock.type == savedBlock.type;
          });
          originalBlock = JSON.parse(JSON.stringify(originalBlock));

          let field = savedBlock.content.fields[i];
          let originalField = originalBlock.content.fields[0];
          if (originalField) {
            field = this.overrideJson(originalField, field);
          }

          field.editMode = false;
          savedBlock.content.fields[i] = field;
        }
      }

      return savedBlock;
    },

    //#endregion ----------- End: Parent Communication Methods---------------

    async fetchAllFonts() {
      this.fontsList = await this.getEmailFonts(true);
    }
  },

  mounted() {
    this.fetCustomerFieldList();
    this.fetchAllFonts();
  }
};
